import { apiFetch, ApiRequestError } from "./api";

/**
 * "Reset chat" on the Model Advisor must start a NEW thread.
 *
 * The advisor's `POST …/advisor/sessions` is get-or-create — one thread per
 * node per person — so on its own it hands back the very thread being reset:
 * the panel blanked its messages, the advisor still replayed the whole old
 * thread on the next turn, and a reload brought the old messages back. The
 * thread the panel is showing is deleted first (`DELETE …/advisor/sessions/:id`,
 * the caller's own thread only), then the POST creates a fresh one.
 */

type AdvisorFetch = <T>(path: string, opts?: { method?: string }) => Promise<T>;

export async function startNewAdvisorThread(
  base: string,
  currentSessionId: string | null,
  fetcher: AdvisorFetch = apiFetch,
): Promise<{ sessionId: string }> {
  if (currentSessionId) {
    try {
      await fetcher(`${base}/${encodeURIComponent(currentSessionId)}`, { method: "DELETE" });
    } catch (e) {
      // Already gone (cleared from another tab) — there is nothing left to clear.
      if (!(e instanceof ApiRequestError && e.status === 404)) throw e;
    }
  }
  const data = await fetcher<{ session: { id: string } }>(base, { method: "POST" });
  return { sessionId: data.session.id };
}
